import React from 'react';

/**
 * Selection state shared by every library list page. Pages pass the resulting
 * `selected` set to their columns and the rest of the API to the
 * `FloatingSelectionBar` + archive / visibility dialogs.
 */
export function useFloatingSelection() {
  const [selected, setSelected] = React.useState<string[]>([]);
  const clear = React.useCallback(() => setSelected([]), []);
  const selectedSet = React.useMemo(() => new Set(selected), [selected]);

  return {
    selected,
    setSelected,
    selectedSet,
    clear
  };
}
